import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-arrow_right",
  "use": "rt-portal-arrow_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-arrow_right\">\r\n<path d=\"M737.7,486.7l-450.8-353c-5.3-4.1-12.9-0.4-12.9,6.3v77.5c0,4.9,2.3,9.6,6.1,12.6l360,281.8l-360,281.8\r\n\tc-3.9,3-6.1,7.7-6.1,12.6V884c0,6.7,7.7,10.4,12.9,6.3l450.8-353C754.1,524.4,754.1,499.6,737.7,486.7L737.7,486.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/arrow_right.svg
// module id = 1297
// module chunks = 91